import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function phoneNumberValidator(localFormat: string): ValidatorFn {
  return (control: FormControl): ValidationErrors | null => {
    const phoneNumberRegex = new RegExp(localFormat);
    const phoneNumber: string = control.value;

    return phoneNumberRegex.test(phoneNumber)
      ? null
      : { invalidPhoneNumber: true };
  };
}
